module.exports = __webpack_public_path__ + "fb071276e62131f01210d9a43d7a2cf1.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/left_hand/boombox.png
// module id = 2986
// module chunks = 0